const mEditionAcademyPersonData = {
  mEditionAcademyPersonData: {
    alerts: {
      updateUsuario: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Su perfil se actualizo exitosamente.'
      }
    },

    inputs: {
      cod_postal: {
        label: 'Código Postal',
        placeholder: 'código postal'
      },

      documento_tipo: {
        label: 'Tipo de Documento'
      },

      documento_numero: {
        label: 'Número de Documento',
        message: '* De 3 a 30 caracteres'
      },

      fisica: {
        label: 'Tipo de Persona'
      },

      localidad: {
        label: 'Localidad',
        placeholder: 'localidad'
      },

      linea1: {
        label: 'Dirección',
        placeholder: 'Mi Dirección'
      },

      linea2: {},

      movil: {
        label: 'Número de Móvil'
      },

      pais: {
        label: 'País'
      },

      provincia: {
        label: 'Provincia'
      },

      razon_social: {
        label: 'Razón Social',
        message: '* De 3 a 150 caracteres',
        placeholder: 'Mi nombre'
      },

      telefono: {
        label: 'Número de Teléfono'
      }
    },

    validation: {
      documento_numero: {
        maxLength: 'La longitud máxima permitida es de 30 caracteres.',
        minLength: 'La longitud mínima permitida es de 3 caracteres.',
        required: 'Número de Documento es requerido. De 3 a 30 caracteres.'
      },

      fisica: {
        required: 'Tipo de Persona es requerido.'
      },

      movil: {
        required: 'Número de Móvil es requerido.'
      },

      razon_social: {
        maxLength: 'La longitud máxima permitida es de 150 caracteres.',
        minLength: 'La longitud mínima permitida es de 3 caracteres.',
        required: 'Razón Social es requerido. De 3 a 150 caracteres.'
      },

      telefono: {
        required: 'Número de Teléfono es requerido.'
      }
    }
  }
}
export default mEditionAcademyPersonData
